const JenisKegiatanSearchCategories = ["pk", "nama_jenis_kegiatan"];

export default JenisKegiatanSearchCategories;
